var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeScanShapeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge-scan-icon-shape",
    transform: "translate(-668 -321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19169",
    "data-name": "Path 19169",
    d: "M134.385,49.235a2.054,2.054,0,0,1-2.054,2.054H120.977V60h11.354A10.778,10.778,0,0,0,143.1,49.235V38.23h-8.71ZM132.331,0H120.977V8.71h11.354a2.046,2.046,0,0,1,2.054,2.054V23.212h8.71V10.765A10.778,10.778,0,0,0,132.331,0M91.806,49.235V38.23H83.1V49.235A10.778,10.778,0,0,0,93.861,60h12.1V51.29h-12.1a2.061,2.061,0,0,1-2.054-2.054M83.1,10.765V23.212h8.71V10.765A2.054,2.054,0,0,1,93.861,8.71h12.1V0h-12.1A10.778,10.778,0,0,0,83.1,10.765",
    transform: "translate(584.904 321)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeScanShapeIcon);
export default __webpack_public_path__ + "static/media/badge-scan-shape-icon.7bfc2be5.svg";
export { ForwardRef as ReactComponent };